var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-header"},[_c('img',{attrs:{"src":require("@/assets/order/icon-fanhui@2x.png"),"alt":"back"},on:{"click":_vm.handleBack}}),_c('p',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }